import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Header from "../components/header";
import Sidebar from "../components/sidebar";
import { useNavigate } from 'react-router-dom';

const PayRole = () => {
	const navigate = useNavigate();
	const [salary, setSalary] = useState();
    const [employee, setEmployee] = useState([]);
    const [formData, setFormData] = useState({
        employeeId: "",
        totalWorkingDays: "",
        numberOfWorkingDays: "",
		salary:"",
    });

    // Fetching Data
    useEffect(() => {
        axios.get("https://api.trucoo.in/payment/allpayrole/")
            .then(response => {
                setEmployee(response.data)
            })
            .catch(error => {
                console.error("There was an error in Fecthing Data", error)
            })
    }, []);


    // Handle input changes
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };


    // Handle form submission
    const handleSubmit = (e) => {
        e.preventDefault();
        

        console.log("Form Submitted: ", formData);



        // Fetch functionality
        axios.post('https://api.trucoo.in/payment/allpayrole/', formData, {
            headers: {
                'Content-Type': 'application/json'
            }
        })
            .then(response => {
                if (response.data.status === "success") {
					navigate(`/PayRole`);
			   } else {
				 console.error(response.data);
			   }

              
            })
            .catch(error => {
                console.error("There was an Error");
            });

    };

	return (

		<>
			<Header />
			<Sidebar />


			<div class="content-wrapper">
				<div class="container-full">

					<section class="content">
						<div class="box box-body">
							<div class="row">

								<div class="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-12">
									<div class="box">
										<div class="box-body">

											<h4 class="box-title text-primary mb-0"><i class="ti-user me-15"></i>Payment Role</h4>
											<hr class="my-15" />

											<div class="row">


												{/* employee id */}
												<div class="col-md-6">
													<div class="form-group">
														<label class="form-label">Employee Id</label>
														<input type="number" class="form-control" name="employeeId" value={formData.employeeId} onChange={handleChange}/>
													</div>
												</div>

												{/* end of the employee id */}


												{/* Salary */}
												<div class="col-md-6">
													<div class="form-group">
														<label class="form-label">Salary</label>
														<input type="number" class="form-control" name="salary" value={formData.salary} onChange={handleChange}/>
													</div>
												</div>
												{/* end of the Salary */}


												{/* totalWorkingDays */}
												<div class="col-md-6">
													<div class="form-group">
														<label class="form-label">Total Working Days</label>
														<input type="number" class="form-control" name="totalWorkingDays" value={formData.totalWorkingDays} onChange={handleChange}/>
													</div>
												</div>

												{/* end of the totalWorkingDays*/}


												{/* number of working days */}
												<div class="col-md-6">
													<div class="form-group">
														<label class="form-label">Number Working Days</label>
														<input type="number" class="form-control" name="numberOfWorkingDays" value={formData.numberOfWorkingDays} onChange={handleChange}/>
													</div>
												</div>
												{/* number of working days end */}

												

											</div>

										</div>
									</div>
								</div>


								<div class="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-12">
									<div class="box">
										<div class="box-body">
											<div class="box-footer" align="center">
												<button type="button" class="btn btn-primary-light me-1"><i class="ti-trash"></i> Cancel</button>
												<button type="submit" class="btn btn-primary"  onClick={handleSubmit}><i class="ti-save-alt"></i> Save</button>
											</div>

										</div>
									</div>
								</div>

							</div>
						</div>
					</section>
				</div>
			</div>


		</>
	)


}

export default PayRole;